import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { HttpParams } from "@angular/common/http";
import { Params, Router } from "@angular/router";
import { ReportsService } from "src/app/features/reports/reports.service";
import { CurrencyPipe, formatDate } from "@angular/common";
import * as moment from "moment";
import { ActivatedRoute } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { AdminViewService } from "src/app/framework/services/admin-view.service";
const helper = new JwtHelperService();

@Component({
  selector: "app-commision",
  templateUrl: "./commision.component.html",
  styleUrls: ["./commision.component.scss"],
  providers: [CurrencyPipe],
})
export class CommisionComponent
  extends FeaturesBaseComponent
  implements OnInit, OnChanges
{
  @Input() commissions;
  @Input() summary;

  isRowSelected: boolean = false;
  searchValue: any;

  columnDefs: any;
  rowData: any = [];
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  isLogSelected: boolean;
  //summary:  Array<any>;
  isButtonDisabled:boolean

  minFromDate;
  maxDate;
  minToDate;
  startDate;
  endDate;
  userRole: string = "";

  constructor(
    private router: Router,
    private reportsService: ReportsService,
    private currencyPipe: CurrencyPipe,
    private activeRoute: ActivatedRoute,
    private adminViewServices:AdminViewService
  ) {
    super();
    const token: string = localStorage.getItem("accessToken");
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;
    this.setGrid();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["commissions"]) {
      this.commissions = changes["commissions"].currentValue;
      this.rowData = this.commissions;
    }
    if (changes["summary"]) {
      this.summary = changes["summary"].currentValue;
    }
  }

  setGrid() {
   
   
    this.columnDefs = [
      {
        field: "transactionDate",
        headerName: "Transaction  Date",
        width: 230,
        cellRenderer: (data) => {
          return moment(data.value).format("MM/DD/YYYY");
        },
      },
      {
        field: "transactionTime",
        headerName: "Transaction Time",
        width: 230,
        cellRenderer: (data) => {
          return moment(data.value).format("hh:mm:ss:a");
        },
      },
      {
        field: "salesDistrRepsCommissionAssignorName",
        headerName: "Sales Rep/Distr",
        width: 230,
      },
      { field: "retailerName", headerName: "Retailer Name", width: 450 },
      { field: "storeName", headerName: "DBA Name", width: 300 },
      {
        field: "retailerAccountNumber",
        headerName: "Retailer Account Number",
        width: 290,
      },
      { field: "sku", headerName: "SKU", width: 150 },
      { field: "productName", headerName: "Product Name", width: 200 },
      { field: "codeGroup", headerName: "Code Group", width: 200 },
      {
        field: "faceValue",
        headerName: "Face Value",
        width: 200,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      
      
    ];
    if (this.userRole == 'Super Admin') {
      this.columnDefs.push({
        field: "commissionGained",
        headerName: "Tila Commission",
        width: 240,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value, "USD", true, "1.2-5");
        },
      })
    }
    if (this.userRole == 'Super Admin' || this.userRole == 'Sub Admin' || this.userRole == 'Sales Rep' || this.userRole == 'Distributor'){
    this.columnDefs.push({
      field: "salesRepCommission",
      headerName: "SalesRep Commission",
      width: 240,
      cellRenderer: (data) => {
        return this.currencyPipe.transform(data.value, "USD", true, "1.2-5");
      },
    })
  }
  if(this.userRole == 'Sales Rep'){
    this.columnDefs.push({
      field: "promoCodeAmt",
      headerName: "Promo Code Amount",
      width: 240,
      cellRenderer: (data) => {
        return this.currencyPipe.transform(data.value, "USD", true, "1.2-5");
      },
    })
  }
    //this.rowData = []
  }
  ngOnInit(): void {
    super.ngOnInit();
     this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  exportData() {
    let header = this.columnDefs.map((columnDef) => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: "Commission.csv",
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs
        .map((c) => c.field || c.colId)
        .filter((c) => !!c),
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      // 
      if (cellParams && cellParams.column.colId === "") {
        return ""; //apply your timestamp formatter
      } else if (
        (cellParams && cellParams.column.colId === "transactionDate") ||
        cellParams.column.colId === "salesDistrRepsCommissionAssignedDate"
      ) {
        return moment(cellParams.value).format("MM/DD/YYYY"); //apply your timestamp formatter
      } else if (
        (cellParams && cellParams.column.colId === "transactionTime") ||
        cellParams.column.colId === "salesDistrRepsCommissionAssignedTime"
      ) {
        return moment(cellParams.value).format("hh:mm:ss:a");
      } else if (cellParams && cellParams.column.colId === "faceValue") {
        return this.currencyPipe.transform(cellParams.value);
      } else return cellParams.value; // no formatting
    };
    this.gridApi.exportDataAsCsv(params);
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }
  onSelectionChanged(e) {
    //;
    this.selectedRows = this.gridApi.getSelectedRows();
    if (
      this.selectedRows &&
      this.selectedRows != [] &&
      this.selectedRows.length! > 0
    ) {
      this.isLogSelected = true;
      return;
    }
    this.isLogSelected = false;
  }

  changeFromDate(e) {
    this.minToDate = e.value;
    this.startDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.endDate != null && this.endDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }
  changeToDate(e) {
    this.endDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.startDate != null && this.startDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }

  getDateChangeResult(startDate, endDate) {
    let params: any = new HttpParams()
      .set("startDate", startDate)
      .set("endDate", endDate);
    this.reportsService.getcommissionSummary(params).subscribe((res) => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.summary = resData;
        this.reportsService.getCommissions(params).subscribe((res) => {
          let resData: any = res;
          if (resData.httpcode == 200) {
            resData = resData.data;
            this.setRowData(res["data"]);
            this.commissions = resData;
          }
        });
      }
    });
  }

  setRowData(rowData: any) {
    this.rowData = rowData;
  }
}
